import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export async function pollProject(id, isDone, { interval = 2500, max = 80 } = {}) {
  let last = null;
  for (let i = 0; i < max; i++) {
    const { data } = await api.get(`/projects/${id}`);
    last = data;
    if (isDone(data)) return data;
    await new Promise((r) => setTimeout(r, interval));
  }
  return last;
}

export function formatError(detail) {
  if (detail == null) return "Algo no ha cargado. Vuelve a intentarlo; tu trabajo sigue aqui.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
